import React, { useState, useCallback, useEffect } from "react";

const SixDoorAdventure = () => {
  // 游戏状态: 'inside-black', 'door-selection', 'solving-door', 'inside-room'
  const [gameState, setGameState] = useState("inside-black");
  const [currentRoom, setCurrentRoom] = useState("black");
  const [unlockedDoors, setUnlockedDoors] = useState([]);
  const [solvedDoors, setSolvedDoors] = useState([]);

  // 所有门的状态（保持原有的状态管理）
  // 黑门状态
  const [blackIsUnlocked, setBlackIsUnlocked] = useState(false);
  const [blackMessage, setBlackMessage] = useState("");
  const [blackCurrentPos, setBlackCurrentPos] = useState({ row: 0, col: 0 });
  const [blackPossibleMoves, setBlackPossibleMoves] = useState([]);
  const [blackMoveHistory, setBlackMoveHistory] = useState([
    { row: 0, col: 0 },
  ]);

  // 红门状态
  const [redCurrentInput, setRedCurrentInput] = useState("");
  const [redDisplayCode, setRedDisplayCode] = useState("F2OU5R");
  const [redIsUnlocked, setRedIsUnlocked] = useState(false);
  const [redMessage, setRedMessage] = useState("");

  // 蓝门状态
  const [blueIsUnlocked, setBlueIsUnlocked] = useState(false);
  const [blueMessage, setBlueMessage] = useState("");
  const [blueSelectedAnswer, setBlueSelectedAnswer] = useState("");
  const [bluePeople, setBluePeople] = useState(Array(14).fill(true));

  // 绿门状态
  const [greenIsUnlocked, setGreenIsUnlocked] = useState(false);
  const [greenMessage, setGreenMessage] = useState("");
  const [greenSelectedAnswer, setGreenSelectedAnswer] = useState("");

  // 白门状态
  const [whiteIsUnlocked, setWhiteIsUnlocked] = useState(false);
  const [whiteMessage, setWhiteMessage] = useState("");

  // 灰门状态
  const [grayGameState, setGrayGameState] = useState(() => ({
    angelTruthful: Math.random() < 0.5,
    leftIsHeaven: Math.random() < 0.5,
    roundNumber: 1,
    gameOver: false,
    result: "",
    questionHistory: [],
  }));
  const [selectedQuestion, setSelectedQuestion] = useState("");
  const [askedTo, setAskedTo] = useState("angel");
  const [lastAnswer, setLastAnswer] = useState("");
  const [showQuestionList, setShowQuestionList] = useState(false);

  // 门的配置 - 均匀分布在圆周上
  const doorConfig = {
    black: {
      name: "黑门",
      color: "bg-gray-900",
      border: "border-gray-700",
      textColor: "text-white",
      angle: 0,
    },
    red: {
      name: "红门",
      color: "bg-red-600",
      border: "border-red-800",
      textColor: "text-white",
      angle: 60,
    },
    blue: {
      name: "蓝门",
      color: "bg-blue-600",
      border: "border-blue-800",
      textColor: "text-white",
      angle: 120,
    },
    green: {
      name: "绿门",
      color: "bg-green-600",
      border: "border-green-800",
      textColor: "text-white",
      angle: 180,
    },
    white: {
      name: "白门",
      color: "bg-white",
      border: "border-gray-400",
      textColor: "text-black",
      angle: 240,
    },
    gray: {
      name: "灰门",
      color: "bg-gray-500",
      border: "border-gray-700",
      textColor: "text-white",
      angle: 300,
    },
  };

  // 检查是否所有门都已解锁
  const allDoorsUnlocked = unlockedDoors.length === 6;

  // 计算门的位置（均匀分布在圆周上）
  const getDoorPosition = (angle) => {
    const radius = 250; // 距离中心的像素半径
    const radian = (angle * Math.PI) / 180;

    // 计算相对于视窗中心的位置
    const x = 50 + radius / 8; // 相对百分比调整
    const y = 50 + radius / 8;

    const offsetX = Math.cos(radian) * 25; // 25% 的半径偏移
    const offsetY = Math.sin(radian) * 25;

    return {
      left: `${Math.max(8, Math.min(92, 50 + offsetX))}%`,
      top: `${Math.max(8, Math.min(92, 50 + offsetY))}%`,
      transform: "translate(-50%, -50%)",
    };
  };
  // 黑门迷宫相关
  const blackInitialGrid = [
    [
      { num: 4, color: "red", isStart: true },
      { num: 2, color: "green" },
      { num: 2, color: "blue" },
      { num: 3, color: "green" },
      { num: 3, color: "blue" },
    ],
    [
      { num: 2, color: "green" },
      { num: 2, color: "blue" },
      { num: 2, color: "green" },
      { num: 2, color: "blue" },
      { num: 2, color: "green" },
    ],
    [
      { num: 3, color: "blue" },
      { num: 2, color: "green" },
      { num: 2, color: "blue" },
      { num: 2, color: "green" },
      { num: 2, color: "blue" },
    ],
    [
      { num: 1, color: "green" },
      { num: 2, color: "blue" },
      { num: 3, color: "green" },
      { num: 2, color: "blue" },
      { num: 3, color: "green" },
    ],
    [
      { num: 3, color: "blue" },
      { num: 2, color: "green" },
      { num: 2, color: "blue" },
      { num: 2, color: "green" },
      { num: "Goal", color: "blue", isGoal: true },
    ],
  ];

  // 监听门的解锁状态
  useEffect(() => {
    if (blackIsUnlocked && !unlockedDoors.includes("black")) {
      setUnlockedDoors([...unlockedDoors, "black"]);
    }
  }, [blackIsUnlocked]);

  useEffect(() => {
    if (redIsUnlocked && !unlockedDoors.includes("red")) {
      setUnlockedDoors([...unlockedDoors, "red"]);
    }
  }, [redIsUnlocked]);

  useEffect(() => {
    if (blueIsUnlocked && !unlockedDoors.includes("blue")) {
      setUnlockedDoors([...unlockedDoors, "blue"]);
    }
  }, [blueIsUnlocked]);

  useEffect(() => {
    if (greenIsUnlocked && !unlockedDoors.includes("green")) {
      setUnlockedDoors([...unlockedDoors, "green"]);
    }
  }, [greenIsUnlocked]);

  useEffect(() => {
    if (whiteIsUnlocked && !unlockedDoors.includes("white")) {
      setUnlockedDoors([...unlockedDoors, "white"]);
    }
  }, [whiteIsUnlocked]);

  useEffect(() => {
    if (
      grayGameState.result.includes("成功") &&
      !unlockedDoors.includes("gray")
    ) {
      setUnlockedDoors([...unlockedDoors, "gray"]);
    }
  }, [grayGameState.result]);

  // 游戏流程控制函数
  const enterDoorSelection = () => {
    setGameState("door-selection");
  };

  const solveDoor = (doorName) => {
    setCurrentRoom(doorName);
    setGameState("solving-door");
  };

  const enterRoom = (doorName) => {
    setCurrentRoom(doorName);
    setGameState("inside-room");
    if (!solvedDoors.includes(doorName)) {
      setSolvedDoors([...solvedDoors, doorName]);
    }
  };

  const leaveRoom = () => {
    setGameState("door-selection");
  };

  // 获取当前门是否已解锁
  const isDoorUnlocked = (doorName) => {
    return unlockedDoors.includes(doorName);
  };

  const isDoorSolved = (doorName) => {
    return solvedDoors.includes(doorName);
  };

  // 黑门相关函数（保持原有逻辑）
  const calculateBlackPossibleMoves = (row, col) => {
    const moves = [];
    const currentCell = blackInitialGrid[row][col];

    if (currentCell.isGoal) return [];

    const steps = currentCell.num;

    if (col - steps >= 0) {
      moves.push({ row, col: col - steps, direction: "left" });
    }
    if (col + steps < 5) {
      moves.push({ row, col: col + steps, direction: "right" });
    }
    if (row - steps >= 0) {
      moves.push({ row: row - steps, col, direction: "up" });
    }
    if (row + steps < 5) {
      moves.push({ row: row + steps, col, direction: "down" });
    }

    return moves;
  };

  const handleBlackMove = (newRow, newCol) => {
    setBlackCurrentPos({ row: newRow, col: newCol });
    setBlackMoveHistory([...blackMoveHistory, { row: newRow, col: newCol }]);

    if (blackInitialGrid[newRow][newCol].isGoal) {
      setBlackIsUnlocked(true);
      setBlackMessage("黑门已打开！");
    }
  };

  const resetBlackGame = () => {
    setBlackCurrentPos({ row: 0, col: 0 });
    setBlackIsUnlocked(false);
    setBlackMessage("");
    setBlackMoveHistory([{ row: 0, col: 0 }]);
  };

  const getBlackCellColor = (cellColor) => {
    switch (cellColor) {
      case "red":
        return "bg-red-400";
      case "green":
        return "bg-green-400";
      case "blue":
        return "bg-blue-400";
      default:
        return "bg-gray-400";
    }
  };

  const isBlackPossibleMove = (row, col) => {
    return blackPossibleMoves.some(
      (move) => move.row === row && move.col === col
    );
  };

  useEffect(() => {
    const moves = calculateBlackPossibleMoves(
      blackCurrentPos.row,
      blackCurrentPos.col
    );
    setBlackPossibleMoves(moves);
  }, [blackCurrentPos]);

  // 蓝门相关函数
  const blueOptions = [
    { label: "A", value: 7 },
    { label: "B", value: 8 },
    { label: "C", value: 9 },
    { label: "D", value: 10 },
    { label: "E", value: 14 },
  ];

  const validateBlueConfiguration = () => {
    const conflicts = [];

    for (let i = 0; i < 14; i++) {
      const leftIndex = (i - 1 + 14) % 14;
      const rightIndex = (i + 1) % 14;

      const person = bluePeople[i];
      const leftPerson = bluePeople[leftIndex];
      const rightPerson = bluePeople[rightIndex];

      const statement = !leftPerson && !rightPerson;
      const isConsistent = person === statement;

      if (!isConsistent) {
        conflicts.push(i);
      }
    }

    return conflicts;
  };

  const handleBluePersonClick = (index) => {
    if (blueIsUnlocked) return;

    const newPeople = [...bluePeople];
    newPeople[index] = !newPeople[index];
    setBluePeople(newPeople);
  };

  const handleBlueAnswer = (selectedValue) => {
    setBlueSelectedAnswer(selectedValue.toString());
    if (selectedValue === 9) {
      setBlueIsUnlocked(true);
      setBlueMessage("蓝门已打开！");
    } else {
      setBlueMessage("答案错误，再仔细分析一下...");
    }
  };

  const renderBluePeople = () => {
    const radius = 110;
    const centerX = 160;
    const centerY = 160;
    const conflicts = validateBlueConfiguration();

    return bluePeople.map((person, index) => {
      const angle = (index * 2 * Math.PI) / 14 - Math.PI / 2;
      const x = centerX + radius * Math.cos(angle);
      const y = centerY + radius * Math.sin(angle);

      const labelRadius = radius + 35;
      const labelX = centerX + labelRadius * Math.cos(angle);
      const labelY = centerY + labelRadius * Math.sin(angle);

      const hasConflict = conflicts.includes(index);
      const isLiar = !person;

      let fillColor = "white";
      if (hasConflict) {
        fillColor = "#ff6b6b";
      } else if (conflicts.length === 0) {
        fillColor = isLiar ? "#51cf66" : "#74c0fc";
      }

      return (
        <g key={index}>
          <circle
            cx={x}
            cy={y}
            r="18"
            fill={fillColor}
            stroke="#333"
            strokeWidth="2"
            className="cursor-pointer hover:stroke-4 transition-all"
            onClick={() => handleBluePersonClick(index)}
          />
          <text
            x={x}
            y={y + 6}
            textAnchor="middle"
            className="text-lg pointer-events-none select-none"
          >
            {person ? "😊" : "😈"}
          </text>
          <text
            x={labelX}
            y={labelY + 4}
            textAnchor="middle"
            className="text-sm fill-gray-700 pointer-events-none select-none font-bold"
          >
            {index + 1}
          </text>
        </g>
      );
    });
  };

  // 绿门相关函数
  const greenOptions = [
    { label: "A", value: 7 },
    { label: "B", value: 8 },
    { label: "C", value: 11 },
    { label: "D", value: 13 },
    { label: "E", value: 15 },
  ];

  const handleGreenAnswer = (selectedValue) => {
    setGreenSelectedAnswer(selectedValue.toString());
    if (selectedValue === 13) {
      setGreenIsUnlocked(true);
      setGreenMessage("绿门已打开！");
    } else {
      setGreenMessage("答案错误，再仔细想想...");
    }
  };

  // 白门相关函数
  const whiteButtons = [
    { id: "5-15", row: 0, col: 0 },
    { id: "5-16", row: 0, col: 1 },
    { id: "6-17", row: 1, col: 0 },
    { id: "5-19", row: 1, col: 2 },
    { id: "6-18", row: 1, col: 1 },
    { id: "7-14", row: 2, col: 0 },
    { id: "7-16", row: 2, col: 1 },
    { id: "8-17", row: 2, col: 2 },
    { id: "8-14", row: 3, col: 0 },
    { id: "8-15", row: 3, col: 1 },
  ];

  const handleWhiteButtonClick = (buttonId) => {
    if (whiteIsUnlocked) return;
    if (buttonId === "7-16") {
      setWhiteIsUnlocked(true);
      setWhiteMessage("白门已打开！");
    } else {
      setWhiteMessage("按钮错误，请重试");
    }
  };

  const renderWhiteButtons = () => {
    const grid = Array(4)
      .fill()
      .map(() => Array(3).fill(null));
    whiteButtons.forEach((button) => {
      grid[button.row][button.col] = button;
    });

    return (
      <div className="grid grid-rows-4 gap-2 max-w-xs mx-auto">
        {grid.map((row, rowIndex) => (
          <div key={rowIndex} className="grid grid-cols-3 gap-2">
            {row.map((button, colIndex) => (
              <div key={colIndex} className="h-12">
                {button ? (
                  <button
                    onClick={() => handleWhiteButtonClick(button.id)}
                    disabled={whiteIsUnlocked}
                    className="w-full h-full bg-gray-300 hover:bg-gray-400 text-black font-bold rounded disabled:opacity-50 text-sm"
                  >
                    {button.id}
                  </button>
                ) : null}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  // 灰门相关函数
  const questions = {
    basic: [
      "1+1=2吗？",
      "你是天使吗？",
      "你是恶魔吗？",
      "左边按钮是天堂吗？",
      "右边按钮是天堂吗？",
      "左边按钮是地狱吗？",
    ],
    nested: [
      "如果我问恶魔，左边按钮是天堂按钮吗？它会怎么回答？",
      "如果我问恶魔，右边按钮是天堂按钮吗？它会怎么回答？",
      "如果我问天使，左边按钮是天堂按钮吗？它会怎么回答？",
      "如果我问天使，右边按钮是天堂按钮吗？它会怎么回答？",
      "如果我问你，左边按钮是天堂按钮吗？你会怎么回答？",
      "如果我问你，右边按钮是天堂按钮吗？你会怎么回答？",
    ],
  };

  const getAnswer = useCallback(
    (question, askerIsAngel) => {
      const { angelTruthful, leftIsHeaven } = grayGameState;
      const speakerTruthful = askerIsAngel ? angelTruthful : !angelTruthful;

      let truthfulAnswer;

      if (question === "1+1=2吗？") {
        truthfulAnswer = true;
      } else if (question === "你是天使吗？") {
        truthfulAnswer = askerIsAngel;
      } else if (question === "你是恶魔吗？") {
        truthfulAnswer = !askerIsAngel;
      } else if (question === "左边按钮是天堂吗？") {
        truthfulAnswer = leftIsHeaven;
      } else if (question === "右边按钮是天堂吗？") {
        truthfulAnswer = !leftIsHeaven;
      } else if (question === "左边按钮是地狱吗？") {
        truthfulAnswer = !leftIsHeaven;
      } else if (
        question === "如果我问恶魔，左边按钮是天堂按钮吗？它会怎么回答？"
      ) {
        const devilWouldAnswerTruthfully = !angelTruthful;
        const devilAnswer = devilWouldAnswerTruthfully
          ? leftIsHeaven
          : !leftIsHeaven;
        truthfulAnswer = devilAnswer;
      } else if (
        question === "如果我问恶魔，右边按钮是天堂按钮吗？它会怎么回答？"
      ) {
        const devilWouldAnswerTruthfully = !angelTruthful;
        const devilAnswer = devilWouldAnswerTruthfully
          ? !leftIsHeaven
          : leftIsHeaven;
        truthfulAnswer = devilAnswer;
      } else if (
        question === "如果我问天使，左边按钮是天堂按钮吗？它会怎么回答？"
      ) {
        const angelWouldAnswerTruthfully = angelTruthful;
        const angelAnswer = angelWouldAnswerTruthfully
          ? leftIsHeaven
          : !leftIsHeaven;
        truthfulAnswer = angelAnswer;
      } else if (
        question === "如果我问天使，右边按钮是天堂按钮吗？它会怎么回答？"
      ) {
        const angelWouldAnswerTruthfully = angelTruthful;
        const angelAnswer = angelWouldAnswerTruthfully
          ? !leftIsHeaven
          : leftIsHeaven;
        truthfulAnswer = angelAnswer;
      } else if (
        question === "如果我问你，左边按钮是天堂按钮吗？你会怎么回答？"
      ) {
        const myAnswer = speakerTruthful ? leftIsHeaven : !leftIsHeaven;
        truthfulAnswer = myAnswer;
      } else if (
        question === "如果我问你，右边按钮是天堂按钮吗？你会怎么回答？"
      ) {
        const myAnswer = speakerTruthful ? !leftIsHeaven : leftIsHeaven;
        truthfulAnswer = myAnswer;
      }

      return speakerTruthful ? truthfulAnswer : !truthfulAnswer;
    },
    [grayGameState]
  );

  const handleQuestionSubmit = () => {
    if (!selectedQuestion || grayGameState.gameOver) return;

    const isAngel = askedTo === "angel";
    const answer = getAnswer(selectedQuestion, isAngel);
    const answerText = answer ? "是" : "否";

    setLastAnswer(`${isAngel ? "天使" : "恶魔"}回答：${answerText}`);

    setGrayGameState((prev) => ({
      ...prev,
      questionHistory: [
        ...prev.questionHistory,
        {
          question: selectedQuestion,
          askedTo: askedTo,
          answer: answerText,
        },
      ],
    }));

    setSelectedQuestion("");
  };

  const handleButtonPress = (side) => {
    if (grayGameState.gameOver) return;

    const { leftIsHeaven } = grayGameState;
    const chosenHeaven = (side === "left") === leftIsHeaven;

    setGrayGameState((prev) => ({
      ...prev,
      gameOver: true,
      result: chosenHeaven ? "成功！你选择了天堂！" : "失败！你选择了地狱！",
    }));
  };

  const randomizeGrayGame = () => {
    setGrayGameState({
      angelTruthful: Math.random() < 0.5,
      leftIsHeaven: Math.random() < 0.5,
      roundNumber: grayGameState.roundNumber + 1,
      gameOver: false,
      result: "",
      questionHistory: [],
    });
    setLastAnswer("");
    setSelectedQuestion("");
  };
  // 红门函数
  const correctRedPassword = "124658";

  const handleRedNumberClick = (num) => {
    if (redCurrentInput.length < 6 && !redIsUnlocked) {
      setRedCurrentInput((prev) => prev + num);
    }
  };

  const handleRedClear = () => {
    setRedCurrentInput("");
    setRedMessage("");
  };

  const handleRedConfirm = () => {
    if (redCurrentInput === correctRedPassword) {
      setRedIsUnlocked(true);
      setRedMessage("红门已打开！");
      setRedDisplayCode("124658");
    } else {
      setRedMessage("密码错误");
      let newDisplay = "F2OU5R";
      if (redCurrentInput.length >= 1)
        newDisplay = newDisplay.replace("F", redCurrentInput[0]);
      if (redCurrentInput.length >= 2)
        newDisplay = newDisplay.replace("O", redCurrentInput[1]);
      if (redCurrentInput.length >= 3)
        newDisplay = newDisplay.replace("U", redCurrentInput[2]);
      if (redCurrentInput.length >= 4)
        newDisplay = newDisplay.replace("R", redCurrentInput[3]);
      setRedDisplayCode(newDisplay);
    }
    setRedCurrentInput("");
  };

  const renderRedDisplay = () => {
    return redDisplayCode.split("").map((char, index) => (
      <span
        key={index}
        className={`inline-block w-8 h-8 text-center border border-gray-400 mx-1 leading-8 ${
          char === "2" || char === "5" ? "bg-gray-200" : "bg-white"
        }`}
      >
        {char}
      </span>
    ));
  };

  // 渲染门选择界面
  const renderDoorSelection = () => (
    <div
      className={`min-h-screen relative overflow-hidden transition-all duration-1000 ${
        allDoorsUnlocked
          ? "bg-black"
          : "bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-900"
      }`}
    >
      {/* 时空漩涡效果 - 仅在所有门解锁后显示 */}
      {allDoorsUnlocked && (
        <>
          {/* 旋转漩涡层 */}
          <div
            className="absolute inset-0 animate-spin"
            style={{ animationDuration: "20s" }}
          >
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full border-4 border-blue-400 opacity-30"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 rounded-full border-4 border-purple-400 opacity-40"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 rounded-full border-4 border-pink-400 opacity-50"></div>
          </div>

          {/* 反向旋转漩涡层 */}
          <div
            className="absolute inset-0 animate-spin"
            style={{ animationDuration: "15s", animationDirection: "reverse" }}
          >
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-72 h-72 rounded-full border-2 border-cyan-400 opacity-25"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-56 h-56 rounded-full border-2 border-yellow-400 opacity-35"></div>
          </div>

          {/* 粒子效果 */}
          <div className="absolute inset-0">
            {[...Array(12)].map((_, i) => (
              <div
                key={i}
                className="absolute w-2 h-2 bg-white rounded-full opacity-70 animate-ping"
                style={{
                  left: `${20 + i * 5}%`,
                  top: `${30 + i * 3}%`,
                  animationDelay: `${i * 0.2}s`,
                  animationDuration: "2s",
                }}
              ></div>
            ))}
          </div>

          {/* 中心吸引效果 */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <div
              className="w-32 h-32 rounded-full animate-pulse opacity-80"
              style={{
                background:
                  "radial-gradient(circle, transparent 0%, rgba(147, 51, 234, 0.6) 50%, black 100%)",
              }}
            ></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-black rounded-full animate-spin border-2 border-white"></div>
          </div>
        </>
      )}

      {/* 普通背景装饰 - 仅在未全部解锁时显示 */}
      {!allDoorsUnlocked && (
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-yellow-300 rounded-full blur-xl"></div>
          <div className="absolute top-3/4 right-1/4 w-24 h-24 bg-blue-300 rounded-full blur-xl"></div>
          <div className="absolute top-1/2 right-1/3 w-16 h-16 bg-green-300 rounded-full blur-xl"></div>
        </div>
      )}

      {/* 中央圆环 */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
        <div
          className={`w-64 h-64 border-4 rounded-full flex items-center justify-center transition-all duration-1000 ${
            allDoorsUnlocked
              ? "border-white bg-black bg-opacity-70 backdrop-blur-lg shadow-2xl shadow-purple-500/50"
              : "border-gray-300 bg-black bg-opacity-30 backdrop-blur-sm"
          }`}
        >
          <div className="text-center text-white">
            {allDoorsUnlocked ? (
              <>
                <h2 className="text-2xl font-bold mb-2 animate-pulse text-purple-300">
                  时空漩涡
                </h2>
                <p className="text-sm opacity-80 text-cyan-200">所有门已开启</p>
                <p className="text-xs opacity-60 mt-2 text-yellow-200">
                  现实正在扭曲...
                </p>
              </>
            ) : (
              <>
                <h2 className="text-2xl font-bold mb-2">密室中心</h2>
                <p className="text-sm opacity-80">选择一扇门进入</p>
              </>
            )}
          </div>
        </div>
      </div>

      {/* 各个门 - 均匀分布 */}
      {Object.entries(doorConfig).map(([key, config]) => {
        const position = getDoorPosition(config.angle);

        return (
          <button
            key={key}
            onClick={() => {
              if (isDoorSolved(key)) {
                enterRoom(key);
              } else {
                solveDoor(key);
              }
            }}
            className={`absolute w-24 h-32 ${config.color} ${
              config.border
            } border-4 rounded-lg shadow-lg hover:scale-105 transition-all transform flex flex-col items-center justify-center ${
              config.textColor
            } font-bold cursor-pointer z-20 ${
              isDoorUnlocked(key) ? "opacity-100" : "opacity-60"
            }`}
            style={{
              ...position,
              ...(allDoorsUnlocked && {
                animationName: "doorSuckIn",
                animationDuration: "12s",
                animationDelay: `${(config.angle / 60) * 0.6}s`,
                animationFillMode: "forwards",
                animationTimingFunction: "ease-in",
              }),
            }}
          >
            <div className="text-2xl mb-1">🚪</div>
            <div className="text-xs">{config.name}</div>
            {isDoorUnlocked(key) && (
              <div
                className={`text-xs mt-1 ${
                  allDoorsUnlocked
                    ? "text-green-300 animate-pulse"
                    : "text-yellow-300"
                }`}
              >
                ✓
              </div>
            )}
          </button>
        );
      })}

      {/* 标题 */}
      <div className="absolute top-8 left-1/2 transform -translate-x-1/2 text-center z-10">
        <h1
          className={`text-4xl font-bold mb-2 transition-all duration-1000 ${
            allDoorsUnlocked ? "text-purple-300 animate-pulse" : "text-white"
          }`}
        >
          {allDoorsUnlocked ? "时空之门已开启" : "逻辑推理-密室逃脱"}
        </h1>
        <p
          className={`transition-all duration-1000 ${
            allDoorsUnlocked ? "text-cyan-300 animate-pulse" : "text-gray-300"
          }`}
        >
          已解锁: {unlockedDoors.length}/6 扇门
        </p>
        {allDoorsUnlocked && (
          <p className="text-yellow-300 text-sm mt-2 animate-bounce">
            🌌 现实的边界正在消失... 🌌
          </p>
        )}
      </div>

      {/* 添加自定义CSS动画样式 */}
      <style jsx>{`
        @keyframes gradient-shift {
          0%,
          100% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
        }

        @keyframes doorSuckIn {
          0% {
            transform: translate(-50%, -50%) scale(1) rotate(0deg);
            opacity: 1;
            filter: blur(0px) brightness(1);
          }
          15% {
            transform: translate(-50%, -50%) scale(0.95) rotate(2deg);
            opacity: 0.98;
          }
          30% {
            transform: translate(-50%, -50%) scale(0.8) rotate(8deg);
            opacity: 0.9;
            filter: blur(0.5px) brightness(1.1);
          }
          50% {
            transform: translate(-50%, -50%) scale(0.6) rotate(25deg);
            opacity: 0.75;
            filter: blur(1px) brightness(1.2);
          }
          70% {
            transform: translate(-50%, -50%) scale(0.3) rotate(60deg);
            opacity: 0.5;
            filter: blur(2px) brightness(1.5);
          }
          85% {
            transform: translate(-50%, -50%) scale(0.1) rotate(120deg);
            opacity: 0.2;
            filter: blur(3px) brightness(2);
          }
          100% {
            transform: translate(-50%, -50%) scale(0) rotate(180deg);
            opacity: 0;
            filter: blur(5px) brightness(3);
          }
        }

        ${allDoorsUnlocked
          ? `
          body {
            animation: gradient-shift 3s ease infinite;
            background: linear-gradient(-45deg, #000000, #1a0033, #330066, #000000);
            background-size: 400% 400%;
          }
        `
          : ""}
      `}</style>
    </div>
  );

  // 渲染房间内部
  const renderInsideRoom = () => {
    // 黑门特殊处理：全黑房间
    if (currentRoom === "black") {
      return (
        <div className="min-h-screen bg-black flex flex-col items-center justify-center">
          <div className="text-center">
            <h1 className="text-3xl font-bold mb-6 text-white opacity-80">
              🚪 黑门内部
            </h1>
            <p className="text-gray-300 mb-8 opacity-60">
              一片漆黑...什么也看不见
            </p>
            <button
              onClick={leaveRoom}
              className="bg-gray-700 hover:bg-gray-600 text-white font-bold py-3 px-8 rounded-lg transition-colors border border-gray-500"
            >
              🚪 离开房间
            </button>
          </div>
        </div>
      );
    }

    // 其他门的正常房间显示
    return (
      <div className="min-h-screen bg-gradient-to-b from-gray-800 to-gray-600 p-8 flex flex-col items-center justify-center">
        <div className="bg-white rounded-lg shadow-2xl p-8 max-w-2xl w-full text-center">
          <h1 className="text-3xl font-bold mb-6 text-gray-800">
            🚪 {doorConfig[currentRoom]?.name} 内部
          </h1>

          {/* 图片预留区域 */}
          <div className="mb-8 bg-gray-100 rounded-lg p-8 border-2 border-dashed border-gray-300">
            <img
              src={`./${currentRoom}-room.jpg`}
              alt={`${doorConfig[currentRoom]?.name}内部`}
              className="w-full h-64 object-cover rounded-lg"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "block";
              }}
            />
            <div className="hidden text-gray-500 text-lg">
              <div className="text-6xl mb-4">🖼️</div>
              <p>图片加载区域</p>
              <p className="text-sm mt-2">
                请在项目目录下放置: {currentRoom}-room.jpg
              </p>
            </div>
          </div>

          <p className="text-gray-600 mb-8">
            恭喜你成功破解了{doorConfig[currentRoom]?.name}
            ！这里是房间的内部空间。
          </p>

          <button
            onClick={leaveRoom}
            className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-8 rounded-lg transition-colors"
          >
            🚪 离开房间
          </button>
        </div>
      </div>
    );
  };

  // 主渲染逻辑
  if (gameState === "door-selection") {
    return renderDoorSelection();
  }

  if (gameState === "inside-room") {
    return renderInsideRoom();
  }

  // solving-door 或 inside-black 状态 - 显示具体的门谜题
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-800 to-gray-600 p-4">
      <div className="flex justify-center">
        {currentRoom === "black" && (
          <div className="bg-gray-900 rounded-lg shadow-2xl p-8 border-4 border-gray-700 max-w-lg w-full">
            <div className="text-center mb-8">
              <h1 className="text-4xl font-bold text-white mb-6">
                🚪 黑色房门
              </h1>
              <div className="text-2xl font-bold text-gray-500 mb-4">
                Goal → open
              </div>

              {/* 迷宫网格 */}
              <div className="bg-gray-200 rounded-lg p-6 mb-6">
                <div className="inline-block border-2 border-gray-600">
                  {blackInitialGrid.map((row, rowIndex) => (
                    <div key={rowIndex} className="flex">
                      {row.map((cell, colIndex) => {
                        const isCurrentPos =
                          blackCurrentPos.row === rowIndex &&
                          blackCurrentPos.col === colIndex;
                        const isPossible = isBlackPossibleMove(
                          rowIndex,
                          colIndex
                        );

                        return (
                          <div
                            key={`${rowIndex}-${colIndex}`}
                            className={`
                              w-16 h-16 flex items-center justify-center text-lg font-bold border border-gray-600 cursor-pointer relative transition-all
                              ${getBlackCellColor(cell.color)}
                              ${
                                isCurrentPos
                                  ? "border-yellow-400 border-4 ring-4 ring-yellow-300 scale-110 z-10"
                                  : ""
                              }
                              ${
                                isPossible
                                  ? "ring-2 ring-purple-400 hover:scale-105"
                                  : ""
                              }
                              ${
                                cell.isGoal
                                  ? "text-white font-black text-xl"
                                  : "text-gray-800"
                              }
                            `}
                            onClick={() => {
                              if (isPossible && !blackIsUnlocked) {
                                handleBlackMove(rowIndex, colIndex);
                              }
                            }}
                          >
                            {isCurrentPos && (
                              <div className="absolute -top-2 -right-2 w-6 h-6 bg-yellow-400 rounded-full border-2 border-white shadow-lg flex items-center justify-center">
                                <div className="w-3 h-3 bg-yellow-600 rounded-full"></div>
                              </div>
                            )}

                            {isPossible && !isCurrentPos && (
                              <div className="absolute -top-1 -right-1 w-4 h-4 bg-purple-400 rounded-full border border-white"></div>
                            )}

                            <span
                              className={`${
                                isCurrentPos ? "font-black text-xl" : ""
                              } ${cell.isGoal ? "text-sm" : ""}`}
                            >
                              {cell.num}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  ))}
                </div>
              </div>

              {/* 控制按钮 */}
              <div className="flex justify-center mb-6">
                <button
                  onClick={resetBlackGame}
                  className="bg-gray-600 hover:bg-gray-500 text-white font-bold py-3 px-6 rounded transition-colors"
                >
                  🔄 重新开始
                </button>
              </div>

              {blackMessage && (
                <div
                  className={`p-3 rounded text-center mb-4 ${
                    blackIsUnlocked
                      ? "bg-green-200 text-green-800"
                      : "bg-red-200 text-red-800"
                  }`}
                >
                  {blackMessage}
                </div>
              )}

              {/* 开门成功提示和进入按钮 */}
              <div className="mt-6 text-center min-h-[100px]">
                {blackIsUnlocked ? (
                  <>
                    <div className="text-4xl mb-2">🎉</div>
                    <div className="text-xl font-bold text-white mb-4">
                      黑门已打开！
                    </div>
                    <button
                      onClick={enterDoorSelection}
                      className="bg-yellow-600 hover:bg-yellow-700 text-white font-bold py-3 px-6 rounded-lg transition-colors"
                    >
                      🚪 进入密室中心
                    </button>
                  </>
                ) : (
                  <div className="opacity-0">
                    <div className="text-4xl mb-2">🎉</div>
                    <div className="text-xl font-bold text-white">占位文字</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {currentRoom === "red" && (
          <div className="bg-red-600 rounded-lg shadow-2xl p-8 border-4 border-red-900 max-w-lg w-full">
            <div className="text-center mb-8">
              <div className="bg-white rounded-lg p-6 mb-4">
                <div className="text-3xl font-bold text-red-800 mb-4">
                  TWO + TWO = FOUR
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg p-4 mb-6 text-center">
              <div className="text-lg font-mono mb-2">{renderRedDisplay()}</div>
            </div>

            <div className="bg-gray-800 rounded-lg p-6">
              <div className="bg-black rounded p-3 mb-4 text-center">
                <div className="text-green-400 font-mono text-xl h-8">
                  {redCurrentInput || "______"}
                </div>
              </div>

              <div className="grid grid-cols-3 gap-2 mb-4">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                  <button
                    key={num}
                    onClick={() => handleRedNumberClick(num.toString())}
                    disabled={redIsUnlocked}
                    className="bg-gray-600 hover:bg-gray-500 text-white font-bold py-3 px-4 rounded disabled:opacity-50"
                  >
                    {num}
                  </button>
                ))}
                <button
                  onClick={() => handleRedNumberClick("0")}
                  disabled={redIsUnlocked}
                  className="bg-gray-600 hover:bg-gray-500 text-white font-bold py-3 px-4 rounded disabled:opacity-50 col-start-2"
                >
                  0
                </button>
              </div>

              <div className="grid grid-cols-2 gap-2">
                <button
                  onClick={handleRedClear}
                  disabled={redIsUnlocked}
                  className="bg-red-600 hover:bg-red-500 text-white font-bold py-2 px-4 rounded disabled:opacity-50"
                >
                  清除
                </button>
                <button
                  onClick={handleRedConfirm}
                  disabled={redIsUnlocked || redCurrentInput.length === 0}
                  className="bg-green-600 hover:bg-green-500 text-white font-bold py-2 px-4 rounded disabled:opacity-50"
                >
                  确认
                </button>
              </div>

              {redMessage && (
                <div
                  className={`mt-4 p-2 rounded text-center ${
                    redIsUnlocked
                      ? "bg-green-200 text-green-800"
                      : "bg-red-200 text-red-800"
                  }`}
                >
                  {redMessage}
                </div>
              )}
            </div>

            {redIsUnlocked && (
              <div className="mt-6 text-center">
                <div className="text-4xl mb-2">🎉</div>
                <div className="text-xl font-bold text-white mb-4">
                  红门已打开！
                </div>
                <div className="flex justify-center space-x-4">
                  <button
                    onClick={leaveRoom}
                    className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded transition-colors"
                  >
                    返回中心
                  </button>
                  <button
                    onClick={() => enterRoom("red")}
                    className="bg-yellow-600 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded transition-colors"
                  >
                    进入房间
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {currentRoom === "blue" && (
          <div className="bg-blue-600 rounded-lg shadow-2xl p-8 border-4 border-blue-800 max-w-lg w-full">
            <div className="text-center mb-8">
              <h1 className="text-4xl font-bold text-white mb-6">
                🚪 蓝色房门
              </h1>

              <div className="bg-white rounded-lg p-6 mb-6">
                <div className="text-lg font-bold text-blue-800 mb-4">
                  圆桌逻辑推理
                </div>
                <div className="text-gray-700 text-sm space-y-2">
                  <div>14个人围成圆圈</div>
                  <div>每人都说："我左右都是骗子"</div>
                  <div>最多可能有多少个骗子？</div>
                </div>
              </div>

              {/* 圆形人物图 */}
              <div className="bg-gray-100 rounded-lg p-6 mb-4">
                <div className="flex justify-center">
                  <svg width="280" height="280" viewBox="0 0 320 320">
                    {/* 圆桌 */}
                    <circle
                      cx="160"
                      cy="160"
                      r="60"
                      fill="#8B4513"
                      stroke="#654321"
                      strokeWidth="4"
                    />

                    {/* 人物 */}
                    {renderBluePeople()}
                  </svg>
                </div>

                {/* 提示信息 */}
                <div className="text-xs text-gray-600 mt-3 space-y-2 text-center">
                  <div>点击人物切换身份：😊=诚实 😈=骗子</div>
                  <div className="flex justify-center space-x-4">
                    <span className="flex items-center">
                      <div className="w-3 h-3 bg-blue-300 rounded mr-1"></div>
                      诚实者
                    </span>
                    <span className="flex items-center">
                      <div className="w-3 h-3 bg-green-400 rounded mr-1"></div>
                      骗子
                    </span>
                    <span className="flex items-center">
                      <div className="w-3 h-3 bg-red-400 rounded mr-1"></div>
                      冲突
                    </span>
                  </div>
                </div>
              </div>

              {/* 状态显示 */}
              <div className="bg-blue-100 rounded-lg p-3 mb-4 text-sm">
                <div className="text-blue-800">
                  <div>
                    当前骗子数量:{" "}
                    <span className="font-bold">
                      {bluePeople.filter((person) => !person).length}
                    </span>
                  </div>
                  <div>
                    逻辑冲突:{" "}
                    <span className="font-bold">
                      {validateBlueConfiguration().length > 0
                        ? `${validateBlueConfiguration().length}个`
                        : "无"}
                    </span>
                  </div>
                </div>
              </div>

              {/* 选项按钮 */}
              <div className="grid grid-cols-5 gap-2 mb-6">
                {blueOptions.map((option) => (
                  <button
                    key={option.label}
                    onClick={() => handleBlueAnswer(option.value)}
                    disabled={blueIsUnlocked}
                    className={`py-2 px-3 rounded font-bold text-sm transition-colors ${
                      blueSelectedAnswer === option.value.toString()
                        ? "bg-yellow-400 text-gray-800 border border-yellow-600"
                        : "bg-white text-blue-800 hover:bg-gray-100"
                    } disabled:opacity-50`}
                  >
                    ({option.label}) {option.value}
                  </button>
                ))}
              </div>

              {blueMessage && (
                <div
                  className={`p-3 rounded text-center mb-4 ${
                    blueIsUnlocked
                      ? "bg-green-200 text-green-800"
                      : "bg-red-200 text-red-800"
                  }`}
                >
                  {blueMessage}
                </div>
              )}

              {blueIsUnlocked && (
                <div className="mt-6 text-center">
                  <div className="text-4xl mb-2">🎉</div>
                  <div className="text-xl font-bold text-white mb-4">
                    蓝门已打开！
                  </div>
                  <div className="flex justify-center space-x-4">
                    <button
                      onClick={leaveRoom}
                      className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded transition-colors"
                    >
                      返回中心
                    </button>
                    <button
                      onClick={() => enterRoom("blue")}
                      className="bg-yellow-600 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded transition-colors"
                    >
                      进入房间
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {currentRoom === "green" && (
          <div className="bg-green-600 rounded-lg shadow-2xl p-8 border-4 border-green-800 max-w-lg w-full">
            <div className="text-center mb-8">
              <h1 className="text-4xl font-bold text-white mb-6">
                🚪 绿色房门
              </h1>

              <div className="bg-white rounded-lg p-6 mb-6">
                <div className="text-lg font-bold text-green-800 mb-4">
                  五边形的秘密
                </div>
                <div className="text-gray-700 text-sm space-y-2">
                  <div>每边三数和相等</div>
                  <div>X是开门的钥匙</div>
                  <div>找到X的值...</div>
                </div>
              </div>

              {/* 五边形图案 */}
              <div className="bg-gray-100 rounded-lg p-6 mb-6 flex justify-center">
                <svg width="260" height="260" viewBox="0 0 300 300">
                  {/* 正五边形的轮廓 */}
                  <polygon
                    points="150,30 256,103 226,216 74,216 44,103"
                    fill="none"
                    stroke="#8B5A00"
                    strokeWidth="4"
                  />

                  {/* 圆圈和数字 */}
                  <circle
                    cx="150"
                    cy="30"
                    r="18"
                    fill="white"
                    stroke="#333"
                    strokeWidth="2"
                  />
                  <text
                    x="150"
                    y="37"
                    textAnchor="middle"
                    className="text-lg font-bold fill-gray-800"
                  >
                    7
                  </text>

                  <circle
                    cx="256"
                    cy="103"
                    r="18"
                    fill="yellow"
                    stroke="#333"
                    strokeWidth="3"
                  />
                  <text
                    x="256"
                    y="110"
                    textAnchor="middle"
                    className="text-lg font-bold fill-red-600"
                  >
                    X
                  </text>

                  <circle
                    cx="226"
                    cy="216"
                    r="18"
                    fill="white"
                    stroke="#333"
                    strokeWidth="2"
                  />

                  <circle
                    cx="74"
                    cy="216"
                    r="18"
                    fill="white"
                    stroke="#333"
                    strokeWidth="2"
                  />

                  <circle
                    cx="44"
                    cy="103"
                    r="18"
                    fill="white"
                    stroke="#333"
                    strokeWidth="2"
                  />

                  <circle
                    cx="203"
                    cy="66"
                    r="18"
                    fill="white"
                    stroke="#333"
                    strokeWidth="2"
                  />
                  <circle
                    cx="241"
                    cy="160"
                    r="18"
                    fill="white"
                    stroke="#333"
                    strokeWidth="2"
                  />
                  <text
                    x="241"
                    y="165"
                    textAnchor="middle"
                    className="text-lg font-bold fill-gray-800"
                  >
                    2
                  </text>

                  <circle
                    cx="150"
                    cy="216"
                    r="18"
                    fill="white"
                    stroke="#333"
                    strokeWidth="2"
                  />
                  <text
                    x="150"
                    y="223"
                    textAnchor="middle"
                    className="text-lg font-bold fill-gray-800"
                  >
                    6
                  </text>

                  <circle
                    cx="59"
                    cy="160"
                    r="18"
                    fill="white"
                    stroke="#333"
                    strokeWidth="2"
                  />
                  <text
                    x="59"
                    y="165"
                    textAnchor="middle"
                    className="text-lg font-bold fill-gray-800"
                  >
                    1
                  </text>
                  <circle
                    cx="97"
                    cy="66"
                    r="18"
                    fill="white"
                    stroke="#333"
                    strokeWidth="2"
                  />
                  <text
                    x="97"
                    y="71"
                    textAnchor="middle"
                    className="text-lg font-bold fill-gray-800"
                  >
                    3
                  </text>
                </svg>
              </div>

              {/* 选项按钮 */}
              <div className="grid grid-cols-5 gap-2 mb-6">
                {greenOptions.map((option) => (
                  <button
                    key={option.label}
                    onClick={() => handleGreenAnswer(option.value)}
                    disabled={greenIsUnlocked}
                    className={`py-2 px-3 rounded font-bold text-sm transition-colors ${
                      greenSelectedAnswer === option.value.toString()
                        ? "bg-yellow-400 text-gray-800 border border-yellow-600"
                        : "bg-white text-green-800 hover:bg-gray-100"
                    } disabled:opacity-50`}
                  >
                    ({option.label}) {option.value}
                  </button>
                ))}
              </div>

              {greenMessage && (
                <div
                  className={`p-3 rounded text-center mb-4 ${
                    greenIsUnlocked
                      ? "bg-green-200 text-green-800"
                      : "bg-red-200 text-red-800"
                  }`}
                >
                  {greenMessage}
                </div>
              )}

              {greenIsUnlocked && (
                <div className="mt-6 text-center">
                  <div className="text-4xl mb-2">🎉</div>
                  <div className="text-xl font-bold text-white mb-4">
                    绿门已打开！
                  </div>
                  <div className="flex justify-center space-x-4">
                    <button
                      onClick={leaveRoom}
                      className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded transition-colors"
                    >
                      返回中心
                    </button>
                    <button
                      onClick={() => enterRoom("green")}
                      className="bg-yellow-600 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded transition-colors"
                    >
                      进入房间
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {currentRoom === "white" && (
          <div className="bg-white rounded-lg shadow-2xl p-8 border-4 border-gray-300 max-w-lg w-full">
            <div className="text-center mb-8">
              <h1 className="text-4xl font-bold text-gray-800 mb-6">
                🚪 白色房门
              </h1>

              <div className="bg-gray-100 rounded-lg p-6 mb-6 text-left">
                <div className="text-lg font-bold text-gray-800 mb-4">
                  正确按钮可开门，A知前、B知后
                </div>
                <div className="space-y-2 text-gray-700">
                  <div>
                    <strong>A：</strong>我不知，不过我知B也不知
                  </div>
                  <div>
                    <strong>B：</strong>我原本不知，如今我知道了
                  </div>
                  <div>
                    <strong>A：</strong>我也知道了
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-6">{renderWhiteButtons()}</div>

            {whiteMessage && (
              <div
                className={`p-4 rounded text-center mb-4 ${
                  whiteIsUnlocked
                    ? "bg-green-100 text-green-800 border-green-300"
                    : "bg-red-100 text-red-800 border-red-300"
                } border`}
              >
                {whiteMessage}
              </div>
            )}

            {whiteIsUnlocked && (
              <div className="mt-6 text-center">
                <div className="text-4xl mb-2">🎉</div>
                <div className="text-xl font-bold text-gray-800 mb-4">
                  白门已打开！
                </div>
                <div className="flex justify-center space-x-4">
                  <button
                    onClick={leaveRoom}
                    className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded transition-colors"
                  >
                    返回中心
                  </button>
                  <button
                    onClick={() => enterRoom("white")}
                    className="bg-yellow-600 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded transition-colors"
                  >
                    进入房间
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {currentRoom === "gray" && (
          <div className="bg-gray-500 rounded-lg shadow-2xl p-8 border-4 border-gray-700 max-w-2xl w-full">
            <div className="text-center mb-8">
              <h1 className="text-4xl font-bold text-white mb-6">
                🚪 灰色房门
              </h1>

              {/* 天使恶魔显示 */}
              <div className="flex justify-around mb-6">
                <div className="text-center">
                  <div className="text-6xl mb-2">👼</div>
                  <div className="text-white font-bold">天使</div>
                </div>
                <div className="text-center">
                  <div className="text-6xl mb-2">😈</div>
                  <div className="text-white font-bold">恶魔</div>
                </div>
              </div>

              <div className="bg-gray-300 rounded-lg p-4 mb-6 text-gray-800">
                <div className="font-bold mb-2">天堂 or 地狱</div>
                <div className="text-sm space-y-1">
                  <div>一真一假</div>
                  <div>随机切换</div>
                  <div>不知真假</div>
                </div>
                <div className="mt-2">• • • • •</div>
              </div>
            </div>

            {/* 按钮区域 */}
            <div className="flex justify-center space-x-8 mb-6">
              <button
                onClick={() => handleButtonPress("left")}
                disabled={grayGameState.gameOver}
                className="w-20 h-20 bg-red-600 hover:bg-red-500 rounded-full border-4 border-gray-400 disabled:opacity-50 transition-all transform hover:scale-105"
              >
                <div className="w-12 h-12 bg-red-500 rounded-full mx-auto"></div>
              </button>
              <button
                onClick={() => handleButtonPress("right")}
                disabled={grayGameState.gameOver}
                className="w-20 h-20 bg-red-600 hover:bg-red-500 rounded-full border-4 border-gray-400 disabled:opacity-50 transition-all transform hover:scale-105"
              >
                <div className="w-12 h-12 bg-red-500 rounded-full mx-auto"></div>
              </button>
            </div>

            {/* 问题选择区域 */}
            <div className="bg-gray-700 rounded-lg p-4 mb-4">
              <div className="mb-4">
                <label className="text-white font-bold block mb-2">
                  询问对象：
                </label>
                <div className="flex space-x-4">
                  <label className="text-white">
                    <input
                      type="radio"
                      value="angel"
                      checked={askedTo === "angel"}
                      onChange={(e) => setAskedTo(e.target.value)}
                      className="mr-2"
                    />
                    天使
                  </label>
                  <label className="text-white">
                    <input
                      type="radio"
                      value="devil"
                      checked={askedTo === "devil"}
                      onChange={(e) => setAskedTo(e.target.value)}
                      className="mr-2"
                    />
                    恶魔
                  </label>
                </div>
              </div>

              <div className="mb-4">
                <button
                  onClick={() => setShowQuestionList(!showQuestionList)}
                  className="bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded mb-2"
                >
                  {showQuestionList ? "隐藏" : "显示"}问题列表
                </button>

                {showQuestionList && (
                  <div className="bg-gray-600 rounded p-3 text-sm">
                    <div className="text-white font-bold mb-2">基础问题：</div>
                    {questions.basic.map((q, i) => (
                      <button
                        key={i}
                        onClick={() => setSelectedQuestion(q)}
                        className="block w-full text-left text-gray-200 hover:text-white p-1 hover:bg-gray-500 rounded"
                      >
                        {q}
                      </button>
                    ))}
                    <div className="text-white font-bold mb-2 mt-4">
                      嵌套问题：
                    </div>
                    {questions.nested.map((q, i) => (
                      <button
                        key={i}
                        onClick={() => setSelectedQuestion(q)}
                        className="block w-full text-left text-gray-200 hover:text-white p-1 hover:bg-gray-500 rounded"
                      >
                        {q}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <div className="mb-4">
                <label className="text-white font-bold block mb-2">
                  选择的问题：
                </label>
                <div className="bg-gray-800 p-2 rounded text-white min-h-[2rem]">
                  {selectedQuestion || "请选择一个问题..."}
                </div>
              </div>

              <button
                onClick={handleQuestionSubmit}
                disabled={!selectedQuestion || grayGameState.gameOver}
                className="bg-green-600 hover:bg-green-500 text-white px-6 py-2 rounded disabled:opacity-50"
              >
                提问
              </button>
            </div>

            {/* 回答显示 */}
            {lastAnswer && (
              <div className="bg-blue-100 border border-blue-300 rounded p-3 mb-4">
                <div className="text-blue-800 font-bold">{lastAnswer}</div>
              </div>
            )}

            {/* 游戏结果 */}
            {grayGameState.result && (
              <div
                className={`rounded p-4 mb-4 text-center font-bold ${
                  grayGameState.result.includes("成功")
                    ? "bg-green-100 text-green-800"
                    : "bg-red-100 text-red-800"
                }`}
              >
                <div className="text-lg">{grayGameState.result}</div>
                <div className="text-sm mt-2">
                  这轮设定：天使
                  {grayGameState.angelTruthful ? "说真话" : "说假话"}，
                  {grayGameState.leftIsHeaven ? "左" : "右"}边按钮是天堂
                </div>
              </div>
            )}

            {grayGameState.result.includes("成功") && (
              <div className="mt-6 text-center">
                <div className="text-4xl mb-2">🎉</div>
                <div className="text-xl font-bold text-white mb-4">
                  灰门已打开！
                </div>
                <div className="flex justify-center space-x-4">
                  <button
                    onClick={leaveRoom}
                    className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded transition-colors"
                  >
                    返回中心
                  </button>
                  <button
                    onClick={() => enterRoom("gray")}
                    className="bg-yellow-600 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded transition-colors"
                  >
                    进入房间
                  </button>
                </div>
              </div>
            )}

            {/* 控制按钮 */}
            <div className="text-center mt-4">
              <button
                onClick={randomizeGrayGame}
                className="bg-yellow-600 hover:bg-yellow-500 text-white px-6 py-2 rounded font-bold"
              >
                🎲 随机切换 (第{grayGameState.roundNumber}轮)
              </button>
            </div>

            {/* 问题历史 */}
            {grayGameState.questionHistory.length > 0 && (
              <div className="mt-4 bg-gray-600 rounded p-3">
                <div className="text-white font-bold mb-2">提问历史：</div>
                {grayGameState.questionHistory.map((item, i) => (
                  <div key={i} className="text-gray-200 text-sm mb-1">
                    问{item.askedTo === "angel" ? "天使" : "恶魔"}：
                    {item.question} → {item.answer}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* 这里可以继续添加其他门的渲染逻辑，为了简化先只实现黑门和红门 */}
      </div>
      <footer className="mt-8 w-full text-center text-sm text-gray-500">
        © {new Date().getFullYear()} 孙维刚教育研究院-陈硕老师 保留所有权利。
      </footer>
    </div>
  );
};

export default SixDoorAdventure;
